import React, { useState } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CFormInput,
  CFormLabel,
} from "@coreui/react-pro";
import userServices from "../../services/user";
import { useAlert } from "../../contexts/AlertContext";

function ChangePasswordModal({ visible, closeModal }) {
  const { showAlert } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const set = (field) => (e) => setForm((p) => ({ ...p, [field]: e.target.value }));

  async function handleSubmit() {
    if (form.newPassword.length < 6) {
      showAlert("A nova senha deve ter no mínimo 6 caracteres.", "error");
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      showAlert("A nova senha e a confirmação não conferem.", "error");
      return;
    }
    setIsLoading(true);
    const res = await userServices.changePassword(form);
    setIsLoading(false);

    if (!res.success) {
      showAlert(res.message, "error");
      return;
    }

    showAlert(res.message || "Senha alterada com sucesso!", "success");
    setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    closeModal();
  }

  return (
    <CModal visible={visible} onClose={closeModal} alignment="center" scrollable={false}>
      <CModalHeader>
        <CModalTitle>Alterar senha</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div className="mb-3">
          <CFormLabel>Senha atual:</CFormLabel>
          <CFormInput type="password" value={form.currentPassword} onChange={set("currentPassword")} />
        </div>
        <div className="mb-3">
          <CFormLabel>Nova senha:</CFormLabel>
          <CFormInput type="password" value={form.newPassword} onChange={set("newPassword")} />
        </div>
        <div className="mb-3">
          <CFormLabel>Confirmar nova senha:</CFormLabel>
          <CFormInput type="password" value={form.confirmPassword} onChange={set("confirmPassword")} />
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" variant="outline" onClick={closeModal} style={{ borderColor: "var(--navy)", color: "var(--navy)" }}>
          Cancelar
        </CButton>
        <CButton type="button" disabled={isLoading} onClick={handleSubmit} style={{ backgroundColor: "var(--navy)", borderColor: "var(--navy)", color: "#fff" }}>
          {isLoading ? "Salvando..." : "Salvar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
}

export default ChangePasswordModal;
